import React from "react";

import AnalyticsTracking from "Utils/AnalyticsTracking";

import { TitleSmall } from "Cobalt/Header";
import { ReduxTrigger, Modal, ModalBody, ModalHeader, ModalFooter } from "Cobalt/Modal";
import BodyText from "Common/BodyText";
import Button from "Common/Button";
import EnterAgesTable from "Common/EnterAges/Components/EnterAgesTable";

import makeBem from "Utils/makeBem";

const bem = makeBem("EnterAgesModal");

class EnterAgesModal extends React.Component {
  handleShow = () => {
    if (this.props.onShow) {
      this.props.onShow();
    }
  };

  handleHide = (reduxTriggerProps) => () => {
    reduxTriggerProps.onHide("enterAgesModal");

    if (this.props.onHide) {
      AnalyticsTracking.trackEvent("modal_closed", {
        location: "enter_ages_modal",
      });
      this.props.onHide();
    }
  };

  handleFinishButtonClicked = (reduxTriggerProps) => () => {
    AnalyticsTracking.trackEvent("cta_clicked", {
      location: "enter_ages_modal",
      label: "finish",
    });
    this.handleHide(reduxTriggerProps)();
  };

  render() {
    return (
      <ReduxTrigger
        name="enterAgesModal"
        modal={(props) => (
          <Modal show={props.show} onShow={this.handleShow} onHide={this.handleHide(props)} className={bem("modal")}>
            <ModalHeader closeButton className={bem("header")}>
              <TitleSmall mb={0} mt={0}>
                Enter Employee Ages
              </TitleSmall>
            </ModalHeader>
            <ModalBody className={bem("body")}>
              <BodyText>To get your precise quote, enter the ages of your employees and their dependents.</BodyText>
              <EnterAgesTable showAddButton />
            </ModalBody>
            <ModalFooter>
              <Button onClick={() => this.handleFinishButtonClicked(props)()}>See Quote</Button>
            </ModalFooter>
          </Modal>
        )}
      />
    );
  }
}

export default EnterAgesModal;
